import {
    NinchatActionType,
    NinchatSendAccessAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'

import {NinchatAccessFoundEvent} from 'api/types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const sendAccess = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatSendAccessAction}`,
    async (arg: NinchatActionParams<NinchatSendAccessAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatSendAccessAction

        try {
            return await ninchatClient.send(params) as NinchatAccessFoundEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
